var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { name: "collection-video-preview", "click-to-close": true },
      on: { "before-open": _vm.modalBeforeOpen, closed: _vm.modalClosed }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal show modal__collection_video_preview modal__new_design"
        },
        [
          _c("section", [
            _c("a", { staticClass: "modal__close" }, [
              _c("i", { staticClass: "icon-close", on: { click: _vm.hide } })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal__body" },
              [
                _vm.previewVideoCard
                  ? _c("VideoContent", {
                      staticClass: "full__width",
                      attrs: { content: _vm.previewVideoCard }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }